import ChatRootIcon from './ChatRootIcon';

export default ChatRootIcon;
